module.exports = __webpack_public_path__ + "img/lg_ring_g_i_1_0.ecad5306.png";